module.exports = __webpack_public_path__ + "img/game-icon.4485cbc3.png";